import{jsx as l,jsxs as $}from"react/jsx-runtime";import a from"styled-components";import k from"../../icons/components/CloseIcon.js";import{getFontSize as C,getCursorType as b,getBackgroundColor as D,getColor as z,getBorderColor as B,getHoverBorderColor as w,getHoverBackgroundColor as H,getHoverColor as j,getActiveBackgroundColor as m,getActiveBorderColor as A,getActiveColor as W,getSufixHoverBackgroundColor as F}from"./styles.js";import"../../utils/utils.js";const I={small:"2px 16px",regular:"3px 16px",large:"7px 16px"},P=a.div`
  font-family: ${({theme:e})=>e.typography.fontBaseFamily};
  font-size: ${({size:e})=>C(e)};
  font-weight: ${({theme:e})=>e.typography.fontBaseBoldWeight};
  line-height: 1.25;
  letter-spacing: 0.1px;
  display: inline-flex;
  cursor: ${b};
  align-items: center;
  background: ${D};
  color: ${z};
  justify-content: center;
  border-width: 1px;
  border-style: solid;
  border-color: ${B};
  border-radius: 1.293rem;
  padding: ${({size:e,isDeletable:n})=>n?"0 0.5rem 0 1rem":I[e]};
  transition:
    color 0.3s ease,
    background-color 0.3s ease,
    border 0.3s ease;
  box-sizing: border-box;
  width: ${({fullWidth:e})=>e?"100%":"auto"};

  ${e=>!e.isDisabled&&e.isClickable&&` &:hover {
    border-color: ${w(e)};
    background-color: ${H(e)};
    color: ${j(e)};
  } &:active {
    background-color: ${m(e)};
    border-color: ${A(e)};
    color: ${W(e)};
  }`}
`,S=a.span`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.5;
`,T=a.span`
  margin-right: 0.625rem;
  display: flex;
  align-items: center;
`,E=a.span`
  display: flex;
  align-items: center;
  cursor: ${b};
  padding: 0.5rem;
  margin-left: 0.25rem;
  margin-right: -0.25rem;
  position: relative;
  z-index: 2;
  &:before {
    transition: opacity 0.3s ease;
    position: absolute;
    height: 0;
    left: 10%;
    content: '';
    height: 80%;
    width: 80%;
    border-radius: 50%;
    z-index: -1;
    background-color: ${F};
    opacity: 0;
  }

  &:active:before {
    background-color: ${m};
    opacity: 1;
  }

  &:hover:before {
    opacity: 1;
  }
`,u=({color:e="primary",children:n,component:h,isDisabled:r,onClick:d,size:f="regular",prefix:s,onDelete:c,variant:g="solid",role:x,...v})=>{const i=!!(d&&!r),t=!!(c&&!r),y=!!s,p=o=>{o.stopPropagation(),c?.(o)};return l(P,{...v,role:x??(i?"button":void 0),onClick:i?d:void 0,tabIndex:i?0:void 0,as:h??(i?"button":"div"),color:e,isDisabled:r,size:f,isClickable:i,isDeletable:t,variant:g,hasPrefix:y,"aria-disabled":r,children:$(S,{children:[s&&l(T,{className:"prefix",children:s}),n,c&&l(E,{role:"button","aria-label":"Remove","aria-disabled":r,onClick:t?p:void 0,color:e,variant:g,isClickable:i,isDisabled:r,isDeletable:!0,size:"regular",tabIndex:t?0:void 0,onKeyDown:o=>{(o.key==="Enter"||o.key===" ")&&t&&(o.preventDefault(),p(o))},children:l(k,{})})]})})};export{u as Chip,u as default};
